import React from "react";
import styled from "styled-components";
import { 
    MELOGY_WHITE,
    SECONDARY,
} from "../../style/colors";
import {
    FONT_SIZE_2XS,
    TITLE_FONT_FAMILY,
    TITLE_LETTER_SPACING,
    TITLE_FONT_WEIGHT,
} from "../../style/fontSettings";
import Button from "../buttons/Button";
import Scrollbar from "../scroll/Scrollbar";

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

const Title = styled.div`
    height: 32px;
    font-size: ${FONT_SIZE_2XS};
    color: ${SECONDARY};
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
`;

const TitleText = styled.div`
    height: 32px;
    font-family: ${TITLE_FONT_FAMILY};
    font-weight: ${TITLE_FONT_WEIGHT};
    letter-spacing: ${TITLE_LETTER_SPACING};
    color: ${MELOGY_WHITE};
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PopoverContentContainer = ({
    title,
    list = [], 
    onClick,
    component,
    selectedListItem,
}) => {
    const content = (
        <>
        {list.map((item, index) => (
            <Button
                key={index}
                text={item}
                height="32px"
                width="168px"
                justifyContent="flex-start"
                isSelected={item === selectedListItem}
                buttonColor="secondary"
                onClick={(event) => onClick(event, item)}
            />
        ))}
        {component}
        </>
    );

    return (
        <ContentContainer>
            <Title>
                <TitleText>{title}</TitleText>
            </Title>
            <Scrollbar>
                {content}
            </Scrollbar>
        </ContentContainer>
    );
};

export default PopoverContentContainer;